<template>
  <lsm-widget
    :title="$t('global.stay_updated')"
    :subtitle="$t('cart.current_displays')"
    icon="fa-suitcase-rolling"
    data-testid="cart-display-widget"
  >
    {{ $t('cart.current_description_1') }}<br>
    {{ $t('cart.current_description_2') }}
    <template #buttons>
      <v-btn
        to="/carts"
        color="primary"
        :text="$t('cart.current_view')"
      />
    </template>
  </lsm-widget>
</template>

<script lang="ts" setup>
import LsmWidget from './LsmWidget.vue';
</script>
